import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { employeeModal, EmployeeModalStore } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { emdash } from 'util/typo'

export const ManagerButton = observer(() => {
  return employee.user ? <Regular /> : <Empty />
})

const Empty = observer(() => {
  const { auth } = employee
  const disabled = !!auth

  const onClick = useLatestCallback(() => {
    employeeModal.open(new EmployeeModalStore())
  })

  return <Button pad={[0, 8]} large primary action={onClick} disabled={disabled}>
    {i18n('LoginEmployee')}
  </Button>
})

const Regular = observer(() => {
  const user = employee.user!
  const { name, email, picture } = user

  const onClick = useLatestCallback(() => {
    employeeModal.open(new EmployeeModalStore(user))
  })

  return <Space button gap={8} pad={[0, 8]} height={40} round={6} onClick={onClick}>
    <Circle size={32} image={picture} icon="person" />
    <Vertical left gap={4}>
      <Typo size={11} one upper medium>
        {name || emdash}
      </Typo>
      <Typo size={11} one secondary>
        {email || emdash}
      </Typo>
    </Vertical>
    <Icon name="unfold_more" size={16} />
  </Space>
})
